export function extractFiltersFromUrl(): {
  filters: { index: string; values: string[] }[];
  view: string;
  isEndOfStock: boolean;
  groupCode: string | null;
  groupValues: string[] | null;
} {
  const urlParams = new URLSearchParams(window.location.search);

  const filters: { index: string; values: string[] }[] = [];
  let view = "thumb";
  let isEndOfStock = false;
  let groupCode: string | null = null;
  let groupValues: string[] | null = null;

  urlParams.forEach((value, key) => {
    if (key === "view") {
      view = value;
    } else if (key === "isEndOfStock") {
      isEndOfStock = value === "true";
    } else {
      const valuesArray = value.split(";").map(decodeURIComponent);
      filters.push({ index: key, values: valuesArray });

      if (!groupCode) {
        groupCode = key;
        groupValues = valuesArray;
      }
    }
  });

  return { filters, view, isEndOfStock, groupCode, groupValues };
}
